/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

import { IAccountGenericTileViewProps } from '@msdyn365-commerce-modules/account-management';
import { IAccountGenericTileProps } from '../definition-extensions/account-generic-tile.ext.props.autogenerated.js';

const AccountGenericTileView: React.FC<IAccountGenericTileViewProps & IAccountGenericTileProps<{}>> = props => {
    const { AccountGenericTile, heading, links } = props;
    const textField = props.config.text;
    const text = textField && <Msdyn365.RichTextComponent text={textField} className='ms-account-generic-tile__description' />;

    return (
        <Module {...AccountGenericTile}>
            {heading}
            {text}
            {links}
        </Module>
    );
};

export default AccountGenericTileView;
